<template>
    <div id="app">
        <el-container v-show="web_view == 'web'">
            <el-header>
                <div class="common-header">
                    <div class="logo">
                    <img @click.stop="returnPage" src="./assets/img/index/toplogo.png" alt />
                </div>
                <el-menu
                    :default-active="defaultActive"
                    class="el-menu-demo"
                    mode="horizontal"
                    @select="handleSelect"
                    background-color="#ea0c0c"
                    text-color="#fff"
                    active-text-color="#fff"
                    :router="router"
                >
                    <el-menu-item index="/" ><p>首页<span class="child-name">HOME</span></p></el-menu-item>
                    <el-menu-item index="/aboutUs"><p>关于我们<span class="child-name">ABOUT US</span></p></el-menu-item>
                    <el-submenu index="/product">
                        <template slot="title"><p style="font-size: 18px;">业务范围<span class="child-name">BUS8INESS SCOPE</span></p></template>
                        <el-menu-item index="/product">经营品类</el-menu-item>
                        <el-menu-item index="/productCar">养车工厂店</el-menu-item>
                        <el-menu-item index="/prodectSite">云仓分布</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="/case"><p>招商加盟<span class="child-name">COOPERATION</span></p></el-menu-item>
                    <el-menu-item index="/goin"><p>联系我们<span class="child-name">CONTACT US</span></p></el-menu-item>
                </el-menu>
                </div>
            </el-header>
            <el-main>
                <router-view />
            </el-main>
            <div class="footer" v-show="isShow">
                <img src="./assets/img/index/bottom.png" alt /> 
                <!-- <div class="bottom-address">
                    <p class="bottom-address-title">安徽心诚科技信息有限公司</p>
                    <div class="bottom-address-line"></div>
                    <div class="bottom-address-long" style="margin-top:33px">
                        <span class="label">公司地址：</span><span class="value">安徽省芜湖市繁昌区繁阳大道繁昌数字经济产业园</span>                              
                    </div>
                    <div class="bottom-address-short" style="margin-top:33px">
                        <span class="label">网址：</span><span class="value">https://www.xinchengzxw.com/</span>
                    </div>
                    <div class="bottom-address-long">
                        <span class="label">华东运营中心：</span><span class="value">安徽省芜湖市弋江区中山南路717号科技产业园2栋3楼</span>
                    </div>
                    <div class="bottom-address-short">
                        <span class="label">服务热线：</span><span class="value">400 996 7650</span>
                    </div>
                </div>                -->
            </div>
        </el-container>
        <el-container v-show="web_view == 'h5'">
            <el-header class="h5-header">
                <div class="common-header-h5">
                    <div class="logo">
                    <img @click.stop="returnPage" src="./assets/img/index/toplogo.png" alt />
                </div>
                <img ref="showsObj" class="nav-icon" @click="showNavFun()" src="./assets/img/index/nav.png" alt />              
                <div ref="shows" class="nav-h5" v-show="showNav">
                    <a @click.stop="toPath('home')">首页</a>
                    <a @click.stop="toPath('aboutUs')">关于我们</a>
                    <a @click.stop="toPath('product')">经营品类</a>
                    <a @click.stop="toPath('productCar')">养车工厂店</a>
                    <a @click.stop="toPath('prodectSite')">云仓分布</a>
                    <a @click.stop="toPath('case')">招商加盟</a>
                    <a @click.stop="toPath('goin')">联系我们</a>
                </div>
                </div>
            </el-header>
            <el-main>
                <router-view />
            </el-main>
            <div class="footer" v-show="isShow">
                <img src="./assets/img/index/bottom.png" alt />   
                           
            </div>
        </el-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showNav:false, // H5导航栏
            web_view:"", // 视图窗口模式 900px以下是手机，以上是PC
            router: true,
            defaultActive: "/",
            isShow: false,
        };
    },
    mounted() {
        let that = this
        document.addEventListener("click", e => {
            if (this.$refs.shows) {
                let self = this.$refs.shows.contains(e.target);
                let selfobj = this.$refs.showsObj.contains(e.target);
                if (!self&&!selfobj) {
                    this.showNav = false;
                }
            }
        })
        if(parseFloat(document.body.clientWidth) < 900){
            this.web_view = 'h5'
            console.log("this.web_view",this.web_view)
        }else{
            this.web_view = 'web'
            console.log("this.web_view",this.web_view)
        }
        window.addEventListener('resize', function() {// 变化后需要做的事
            if(parseFloat(document.body.clientWidth) < 900){
                this.web_view = 'h5'
                console.log("this.web_view",this.web_view)
            }else{
                this.web_view = 'web'
                console.log("this.web_view",this.web_view)
            }
            that.$forceUpdate()
        })
    },
    methods: {
        returnPage(){
            window.location.href = 'https://xinchengzxw.com/'
        },
        toPath(e){
            this.$router.push({ name: e });
            this.showNav = false;
        },
        showNavFun(){
            this.showNav = true
        },
        handleSelect(key) {
            console.log(key)
            if(key == '/aboutUs'||key == '/product'||key == '/prodectSite'||key == '/productCar'||key == '/case'||key == '/goin' ){
                this.isShow = true
            }else{
                this.isShow = false
            }
        },
    },
};
</script>

<style lang="scss">
* {
    padding: 0;
    margin: 0;
}
html,
body {
    height: 100%;
    background: #333;
}

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

.el-menu.el-menu--horizontal {
    border-bottom: none !important;
}

.el-menu--horizontal>.el-menu-item {
    width: 140px;
    text-align: center;
    float: left;
    height: 80px !important;
    line-height: 60px !important;
    margin: 0;
    border-bottom: 0px solid transparent !important;
    color: #fff;
    font-size: 18px;
    letter-spacing: 1px;
}

.el-submenu__title {
    width: 140px;
    text-align: center;
    float: left;
    height: 80px !important;
    line-height: 60px !important;
    margin: 0;
    border-bottom: 0px solid transparent !important;
    color: #fff;
    font-size: 18px;
    letter-spacing: 1px;
}

.child-name{
    position: absolute;
    bottom: -2px;
    width: 100%;
    text-align: center;
    left: 0;
    font-size: 12px;
    letter-spacing: 0px;
}

.el-header {
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;  
    height: 80px !important;
    background: #ea0c0c;

    .common-header {
        display: flex;
        justify-content: space-between;
        align-content: center;
        width: 1200px;
        margin: 0 auto;
        .logo {
            width: 280px;
            padding: 10px;
            img {
                height: 40px;
                margin-top: 8px;
            }
        }
    }
    .common-header-h5 {
        display: flex;
        justify-content: space-between;
        align-content: center;
        width: 1200px;
        margin: 0 auto;
        .logo {
            width: 280px;
            padding: 10px;
            img {
                height: 40px;
                margin-top: 8px;
            }
        }
    }
}

.el-main {
    padding: 0 !important;
}

.el-carousel__indicators--horizontal {
    display: none !important;
}

.footer {
    text-align: center;
    width: 100%;
    height: 330px;
    overflow: hidden;
    background-color: #111;
    padding: 40px 0;
    box-sizing: border-box;
    position: relative;
}


.h5-header {
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;  
    height: 48px !important;
    padding: 0 10px !important;
    background: #ea0c0c;

    .common-header-h5 {
        display: flex;
        justify-content: space-between;
        align-content: center;
        width: 100%;
        margin: 0 auto;
        .logo {
            width: 280px;
            padding: 10px;
            img {
                height: 18px !important;
                margin-top: 7px !important;
            }
        }
    }
}
.nav-icon {
    height: 32px;
    margin-top: 8px;
}
.nav-h5 {
    z-index: 9999;
    background: #fff;
    width: 120px;
    top: 48px;
    right: 0;
    position: absolute;
    a{
        display: inline-block;
        width: 100%;
        line-height: 36px;
        font-size: 14px;
        text-align: center;
    }
}

.bottom-address {
    position: absolute;
    background: #111111;
    height: 100px;
    bottom: 0px;
    width: 100%;

    .bottom-address-title {
        width: calc(50% - 20px);
        float: left;
        text-align: right;
        height: 100px;
        line-height: 100px;
        color: #fff;
        font-size: 26px;
        letter-spacing: 5px;
    }
    .bottom-address-line {
        float: left;
        width: 2px;
        height: 30px;
        background: #fff;
        margin-left: 9px;
        margin-right: 9px;
        margin-top: 35px;
    }
    .bottom-address-long{
        width: 380px;
        float: left;
        color: #fff;
        font-size: 12px;
        text-align: left;
        margin-right: 2%;
    }
    .bottom-address-short{
        width: 18%;
        float: left;
        color: #fff;
        font-size: 12px;
        text-align: left;
    }
}
</style>
